import React, { useState, useEffect } from "react";
import { Table, Button, Input, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import axiosInstance from "utilities/axios";
import MarkupModal from "./components/MarkupModal";
import NewMarkupModal from "./components/NewMarkupModal";

const Markups = () => {
  const [markups, setMarkups] = useState([]);
  const [search, setSearch] = useState("");

  const [selectedMarkup, setSelectedMarkup] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const [openNewMarkupModal, setOpenNewMarkupModal] = useState(false);

  const fetchMarkups = () => {
    axiosInstance
      .get("/markups", { params: { search } })
      .then((response) => {
        setMarkups(response.data);
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: error.message,
        });
      });
  };

  useEffect(() => {
    fetchMarkups();
  }, [search]);

  const columns = [
    {
      title: "Markup",
      dataIndex: "markupName",
      key: "markupName",
      sorter: (a, b) => a.markupName.localeCompare(b.markupName),
    },
    {
      title: "Value",
      dataIndex: "markupValue",
      key: "markupValue",
      sorter: (a, b) => a.markupValue - b.markupValue,
      render: (text, record) => {
        return record.valueType === "percentage"
          ? `${record.markupValue}%`
          : `$${record.markupValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      },
    },
    {
      title: "Effective Date",
      dataIndex: "effectiveDate",
      key: "effectiveDate",
      sorter: (a, b) => new Date(a.effectiveDate) - new Date(b.effectiveDate),
    },
    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      key: "expirationDate",
      sorter: (a, b) => new Date(a.expirationDate) - new Date(b.expirationDate),
      filters: [
        { text: "Expired", value: "expired" },
        { text: "Active", value: "active" },
      ],
      defaultFilteredValue: ["active"],
      onFilter: (value, record) => {
        if (value === "expired") {
          return record.expirationDate < new Date().toISOString();
        } else {
          // return where records are not expired or have no expiration date
          return (
            record.expirationDate >= new Date().toISOString() ||
            !record.expirationDate
          );
        }
      },
      render: (text, record) =>
        record.expirationDate ? record.expirationDate : "No expiration date",
    },
    {
      title: "Details",
      dataIndex: "",
      key: "x",
      width: 100,
      render: (_, record) => (
        <Button
          onClick={() => {
            setSelectedMarkup(record);
            setOpenModal(true);
          }}
        >
          Details
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "32px" }}>
      <div style={{ display: "flex" }}>
        <Input.Search
          placeholder="Search Markups"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          size="large"
        />
        <Button
          type="primary"
          size="large"
          style={{ marginLeft: "16px" }}
          onClick={() => setOpenNewMarkupModal(true)}
          icon={<PlusOutlined />}
        >
          Add Markup
        </Button>
      </div>
      <div style={{ marginTop: "16px" }}>
        <Table bordered dataSource={markups} columns={columns} rowKey="id" />
      </div>
      <MarkupModal
        markup={selectedMarkup}
        open={openModal}
        onClose={() => setOpenModal(false)}
        onChange={fetchMarkups}
      />
      <NewMarkupModal
        visible={openNewMarkupModal}
        onClose={() => setOpenNewMarkupModal(false)}
        onChange={fetchMarkups}
      />
    </div>
  );
};

export default Markups;
